import axiosInstance from '../../../../config/axiosInstance';
import { UserValidation } from "../../views/User/Validation/UserValidation";


const handleChange = (event, formData, setFormData) => {
  const { name, value } = event.target;
  setFormData({
    ...formData,
    [name]: value,
  });
};

const handleSubmit = async (event, formData, setFormData, setErrors,redirectCallback,redirectUserList) => {
  event.preventDefault();
  
  const formErrors = UserValidation(formData);
  setErrors(formErrors);
  if (Object.keys(formErrors).length === 0) {
    try {
      const CompanyID=localStorage.getItem("CompanyID");
      formData.formData.HostCompanyID=CompanyID;
      
      const response = await axiosInstance.post(`/Setup/CreateUser`, formData);
      setFormData({
        UserName: '',
        DisplayName: '',
        UserPassword: '',
        ConfirmPassword: '',
        RoleID: '',
        TeamID: '',
        Email: '',
        ExchangePassword: '',
        Rate: '',
        Cost: '',
        AdditionalRate: '',
        AdditionalCost: '',
        WeekendRate: '',
        WeekendCost: '',
        RateMethod: ''
        // Reset other fields as needed
      });
      return response.data.message;
    } catch (error) {
      console.error('Error posting data:', error);
    }
  }
  else
  {
    return "Validation Error";
  }
};

export { handleChange, handleSubmit };